import { UserListQuery } from "@common/model/interface/user";
const userUrl = "zh-user/api/v1";

// refreshToken换取token
export function getAccessTokenApi(request, query: UserListQuery) {
  return request({
    url: `${userUrl}/token/refresh`,
    method: "POST",
    data: query
  }).then(res => {
    return res.data;
  });
}

// refreshToken换取token
export function checkTokenExpiredApi(request, query: UserListQuery) {
  return request({
    url: `${userUrl}/token/expire/test`,
    method: "GET",
    params: query
  }).then(res => {
    return res.data;
  });
}

// 根据用户id/id集合获取用户信息/列表信息
export function getUserIdsListApi(request, data: UserListQuery) {
  return request({
    url: `${userUrl}/user/precise/list/query`,
    method: "POST",
    data
  }).then(res => res.data);
}

// 根据token获取用户信息
export function getUserInfoByTokenApi(request) {
  return request({
    url: `${userUrl}/user/whole-user/details/query`,
    method: "GET"
  }).then(res => res.data);
}
// 根据token获取name
export function getUserNameByTokenApi(request) {
  return request({
    url: `${userUrl}/user/name`,
    method: "GET"
  }).then(res => res.data);
}
// 获取个人账号信息
export function getAccountInfoApi(request) {
  return request({
    url: `${userUrl}/user/account/details/query`,
    method: "GET"
  }).then(res => {
    return res.data;
  });
}

// 获取个人权限
export function getUserPerimissionsApi(request) {
  return request({
    url: `${userUrl}/permission/index/query`,
    method: "GET"
  }).then(res => {
    return res.data;
  });
}

// 获取租户管理员列表(primaryAccount-->0:没有所属租户的账号 + 该组织下的主账号列表; 1:主账号; 2:除平台管理员外的所有账号)
export function getUserTenantApi(request, query: any) {
  return request({
    url: `${userUrl}/user/all/account/query`,
    method: "GET",
    params: query
  }).then(res => {
    return res.data;
  });
}

// 退出登录
export function loginOutApi(request) {
  return request({
    url: `${userUrl}/user/logOut`,
    method: "POST"
  }).then(res => res.data);
}
